import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as r } from "react";
const i = ({
  title: l,
  titleId: o,
  ...c
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M860.623 813.135c0-.405.171-.768.171-1.173v-.064h-.235c-.896-19.456-2.197-38.891-5.099-58.133-2.987-19.84-7.509-39.595-15.275-58.005-6.869-16.32-16.405-31.253-28.501-43.733-13.269-13.632-29.099-24.085-45.781-32.341-21.355-10.603-44.117-17.877-66.987-23.829-14.123-3.669-28.373-6.805-42.688-9.621a1145.441 1145.441 0 0 0-23.851-4.395c-8.448-1.472-18.155-1.643-25.899-5.781-8.064-4.309-13.973-13.333-10.987-23.04 2.603-8.427 9.835-14.507 15.851-20.181 5.013-4.736 9.792-9.771 14.336-15.04 24.107-27.947 41.259-62.187 52.224-98.069 19.733-5.248 34.987-24.896 35.989-51.925.789-21.547-7.723-38.144-20.885-47.253.021-1.835.192-3.627.192-5.461 0-143.68-83.072-214.912-180.309-214.912h-.512c-96.917 0-180.309 71.232-180.309 214.912 0 1.835.149 3.627.171 5.461-13.163 9.109-21.653 25.707-20.864 47.253 1.003 27.029 16.256 46.677 35.989 51.925 10.965 35.883 28.096 70.123 52.224 98.069a195.04 195.04 0 0 0 14.336 15.04c6.016 5.675 13.227 11.755 15.829 20.181 2.987 9.707-2.923 18.731-10.987 23.04-7.723 4.139-17.429 4.309-25.877 5.781a1140.829 1140.829 0 0 0-23.872 4.395c-14.293 2.816-28.544 5.952-42.688 9.621-22.869 5.952-45.611 13.227-66.987 23.829-16.661 8.256-32.512 18.709-45.76 32.341-12.117 12.48-21.653 27.413-28.523 43.733-7.744 18.411-12.267 38.165-15.253 58.005-2.901 19.243-4.224 38.677-5.099 58.133h-.235c0 .021-.021.043-.021.064 0 .405.171.768.192 1.173-.043 1.024-.149 2.048-.192 3.093h.661c6.891 60.949 159.595 109.739 347.52 109.739 187.904 0 340.629-48.789 347.52-109.739h.64c-.043-1.045-.128-2.069-.171-3.093z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), h = r(i);
export {
  h as default
};
